import { render, staticRenderFns } from "./TopLabels.vue?vue&type=template&id=36d3a52d&scoped=true"
import script from "./TopLabels.vue?vue&type=script&lang=js"
export * from "./TopLabels.vue?vue&type=script&lang=js"
import style0 from "./TopLabels.vue?vue&type=style&index=0&id=36d3a52d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3a52d",
  null
  
)

export default component.exports